import AreaContainer from "../AreaContainer";
import styles from './schemeCard.module.css';
import globalStyles from '../result.module.css';
import LazyImage from "components/LazyImage";
import { useRef } from 'react';
import Link from "next/link";
import { checkLoggedIn } from "context/context";
import TEXT from 'localisation'

type Props = {
    thumbnail: Image, 
    category_code: string,
    name : string,
    description: string, 
    owners: Owners[], 
    agents: Agents[], 
    portfolio: {
        styles: {
            dark: string
        }
    },
    uri_lowercase: string, 
    id: number,
    sponsored: boolean
}

type Image = {
    format: {
        w200: {
            uri: string
        }
    }
};

type Owners = {
    paying_client: boolean,
    id: number,
    company_name: string,
    logo_uri: string
};

type Agents = {
    company_id: number,
    company_name: string
};

const schemeCard = ({ thumbnail, name, description, owners, agents, portfolio, uri_lowercase, id, sponsored, category_code }: Props) => {
    const thumbnail_uri = thumbnail?.format?.w200?.uri;
    const resultLinkRef = useRef<HTMLAnchorElement>(null);
    const loggedIn = checkLoggedIn();
    return (
        <AreaContainer area="schemeCard" style={null} extraClass={null}>
            <div className={styles.DemoWrapper}>
                <h2 className={globalStyles.subTitleText}>This Property is Part of a {TEXT[`SCHEME_${category_code}_LABEL_UPPER_SINGLE`]} </h2>
                <div className={styles.cardContainer} style={{ background: portfolio?.styles?.dark ? portfolio.styles.dark : '#9ebbe5' }}>
                    <div className={styles.innerCard}
                        onClick={(e) => {
                            if (
                                (e.target as HTMLElement).tagName.toUpperCase() !== "BUTTON" &&
                                (e.target as HTMLElement).tagName.toUpperCase() !== "A"
                            ) {
                                resultLinkRef?.current?.click();
                            }
                        }}
                    >

                        {thumbnail_uri && (
                            <div className={`${styles.thumbNail}`}>
                                <LazyImage
                                    src={`${process.env.NEXT_PUBLIC_APP_MEDIA_URL}${thumbnail_uri}`}
                                    layout="fill"
                                    objectFit="cover"
                                />
                                {sponsored && (
                                    <div className={styles.badgeCard}>
                                        <span>Featured</span>
                                    </div>
                                )}
                            </div>
                        )}

                        <a
                            className={`${styles.cardHeading}`}
                            aria-label={`View ${name} on Completely Retail`}
                            ref={resultLinkRef}
                        >
                            <h2>
                                {name}
                            </h2>
                        </a>

                        <p>
                            {description}
                        </p>

                        {((agents && agents.length !== 0) || (owners && owners.length > 0)) && (

                            <div className={styles.repsContainer} >
                                {agents && agents.length !== 0 && (
                                    <div className={styles.agentContainer}>
                                        {agents.map((company) => {
                                            if (loggedIn) {
                                                return (
                                                    <Link key={company.company_id} href={`/overview/${company.company_id}`} passHref prefetch={false} legacyBehavior>
                                                        <a
                                                            className={styles.marketedBy}
                                                            onClick={(e) => e.stopPropagation()}
                                                            title={"Explore " + company.company_name + " on Completely Retail"}
                                                            itemScope itemType="https://schema.org/Organization" itemProp="name"
                                                        >
                                                            {company.company_name}
                                                        </a>
                                                    </Link>
                                                )
                                            } else {
                                                return (
                                                    <span key={company.company_id}>
                                                        {company.company_name}
                                                    </span>
                                                )
                                            }
                                        }
                                        )}
                                    </div>
                                )}
                                {owners && owners.length > 0 && (
                                    <div className={styles.ownersContainer}>
                                        {owners.filter(o => Boolean(o.paying_client)).map((owner) => (
                                            <Link key={owner.id} href={`/overview/${owner.id}`} passHref prefetch={false} onClick={(e) => e.stopPropagation()} title={"Explore " + owner.company_name + " on Completely Retail"}>
                                                <img alt={`${owner.company_name} logo`} src={`${process.env.NEXT_PUBLIC_APP_MEDIA_URL}${owner.logo_uri}`} loading="lazy" height="auto" width="auto"></img>
                                            </Link>

                                        ))
                                        }
                                    </div>
                                )}
                            </div>
                        )}

                    </div>

                    <div className={styles.buttonContainer}>
                        <Link href={`/scheme/${uri_lowercase}-${id}`} passHref prefetch={false} >
                            <button className={styles.primaryButton}>View {name}</button>
                        </Link>
                    </div>

                </div>
            </div>
        </AreaContainer>
    )
}

export default schemeCard;